// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { Icon } from 'iconsax-react';

const EditIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const id = React.useId();
  const clipId = `${id}-clip`;
  const maskId = `${id}-mask`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g clipPath={`url(#${clipId})`}>
        <mask id={maskId} style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <path d="M15.5 0.5V15.5H0.5V0.5H15.5Z" fill="white" stroke="white" />
        </mask>
        <g mask={`url(#${maskId})`}>
          <path d="M9.99998 15.1666H5.99998C2.37998 15.1666 0.833313 13.62 0.833313 9.99998V5.99998C0.833313 2.37998 2.37998 0.833313 5.99998 0.833313H7.33331C7.60665 0.833313 7.83331 1.05998 7.83331 1.33331C7.83331 1.60665 7.60665 1.83331 7.33331 1.83331H5.99998C2.92665 1.83331 1.83331 2.92665 1.83331 5.99998V9.99998C1.83331 13.0733 2.92665 14.1666 5.99998 14.1666H9.99998C13.0733 14.1666 14.1666 13.0733 14.1666 9.99998V8.66665C14.1666 8.39331 14.3933 8.16665 14.6666 8.16665C14.94 8.16665 15.1666 8.39331 15.1666 8.66665V9.99998C15.1666 13.62 13.62 15.1666 9.99998 15.1666Z" fill={color || 'currentColor'} />
          <path d="M5.6667 11.7936C5.26003 11.7936 4.8867 11.647 4.61337 11.3803C4.2867 11.0536 4.1467 10.5803 4.22003 10.0803L4.5067 8.07365C4.56003 7.68698 4.81337 7.18698 5.0867 6.91365L10.34 1.66035C11.6667 0.333677 13.0134 0.333677 14.34 1.66035C15.0667 2.38701 15.3934 3.12701 15.3267 3.86701C15.2667 4.46701 14.9467 5.05368 14.34 5.65368L9.08671 10.907C8.81338 11.1803 8.31338 11.4336 7.92671 11.487L5.92003 11.7736C5.83337 11.7936 5.7467 11.7936 5.6667 11.7936ZM11.0467 2.36701L5.79337 7.62031C5.6667 7.74698 5.52003 8.04031 5.49337 8.21365L5.2067 10.2203C5.18003 10.4136 5.22003 10.5736 5.32003 10.6736C5.42003 10.7736 5.58003 10.8136 5.77337 10.787L7.78005 10.5003C7.95338 10.4736 8.25338 10.327 8.37338 10.2003L13.6267 4.94701C14.06 4.51368 14.2867 4.12701 14.32 3.76701C14.36 3.33368 14.1334 2.87368 13.6267 2.36035C12.56 1.29368 11.8267 1.59368 11.0467 2.36701Z" fill={color || 'currentColor'} />
          <path d="M13.2333 6.55349C13.1867 6.55349 13.14 6.54683 13.1 6.53349C11.3467 6.04016 9.95335 4.64683 9.46002 2.89349C9.38668 2.62683 9.54002 2.35349 9.80668 2.27349C10.0734 2.20016 10.3467 2.35349 10.42 2.62016C10.82 4.04016 11.9467 5.16683 13.3667 5.56683C13.6334 5.64016 13.7867 5.92016 13.7134 6.18683C13.6534 6.41349 13.4534 6.55349 13.2333 6.55349Z" fill={color || 'currentColor'} />
        </g>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { EditIcon };
